// Navbar.jsx
import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";

const links = [
  { to: "/", label: "Meet Salman", end: true },
  { to: "/corporate", label: "Corporate" },
  { to: "/gallery", label: "Gallery" },
  { to: "/legacy", label: "Legacy" },
  { to: "/character", label: "Character" },
  { to: "/intelligence", label: "Intelligence" },
  { to: "/consciousness", label: "Consciousness" },
  { to: "/GraphNavPanel", label: "Graphs" },
];

function Navbar() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [menuOpen, setMenuOpen] = useState(false);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) setMenuOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Close mobile menu with Escape key
  useEffect(() => {
    if (!menuOpen) return;
    const handleKey = (e) => {
      if (e.key === "Escape") setMenuOpen(false);
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [menuOpen]);

  const toggleMenu = () => setMenuOpen((open) => !open);
  const closeMenu = () => setMenuOpen(false);

  const renderLinks = (onClick) =>
    links.map(({ to, label, end }) => (
      <li key={to}>
        <NavLink to={to} end={end} onClick={onClick}>
          {label}
        </NavLink>
      </li>
    ));

  return (
    <nav className="nav-wrapper">
      {/* Mobile Header with Hamburger */}
      {isMobile && (
        <div className="nav-mobile-header">
          <button
            className="nav-hamburger"
            onClick={toggleMenu}
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
          >
            <div className={`nav-bar nav-bar1 ${menuOpen ? "open" : ""}`} />
            <div className={`nav-bar nav-bar2 ${menuOpen ? "open" : ""}`} />
            <div className={`nav-bar nav-bar3 ${menuOpen ? "open" : ""}`} />
          </button>
        </div>
      )}

      {/* Desktop Sidebar */}
      {!isMobile && <ul className="nav-links nav-sidebar">{renderLinks()}</ul>}

      {/* Mobile Modal Menu */}
      {isMobile && menuOpen && (
        <div className="nav-mobile-modal">
          <ul className="nav-links nav-modal-links">
            {renderLinks(closeMenu)}
          </ul>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
